import { defineComponent as _defineComponent } from 'vue'
import { formatPrice } from "@/helpers/transformation/price";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import BuilderLoanAssumptions from "@/components/builder/BuilderLoanAssumptions.vue";
  import { ref, computed } from "vue";
  import { hexToRgba } from "@/helpers/customer/changePrimaryColor";
  import { BuilderTimePeriodEnum } from "@/enums/BuilderTimePeriod";
  import { useIsDesktop } from "@/features/useIsDesktop";
  import router from "@/router";
  import { BuilderQuote } from "@/types/BuilderQuote";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderLoanCalculator',
  props: {
    packagePrice: {
      type: Number,
      required: true,
    },
    quote: {
      type: Object as () => BuilderQuote,
      required: true,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const { isDesktop } = useIsDesktop(680);

  const estateId = router.currentRoute.value.params.estateId;

  const depositPercentage = ref(0.05);
  const interestRate = ref(5.5);
  const loanAmount = ref(0);
  const loanTerm = ref(30);

  const isAssumptionsOpen = ref(false);
  const fadeInEffect = ref(false);

  const timePeriod = [
    BuilderTimePeriodEnum.PER_WEEK,
    BuilderTimePeriodEnum.PER_MONTH,
  ];
  const selectedTimePeriod = ref<BuilderTimePeriodEnum>(
    BuilderTimePeriodEnum.PER_WEEK
  );

  const selectTimePeriod = (period: BuilderTimePeriodEnum) => {
    selectedTimePeriod.value = period;
  };

  const calculatedLoanAmount = computed(() => {
    const priceWithDeposit =
      props.packagePrice - props.packagePrice * depositPercentage.value;

    return priceWithDeposit.toFixed(2);
  });

  const calculateRepayments = () => {
    const interestRatePerMonth = interestRate.value / 100 / 12;
    const numberOfPayments = loanTerm.value * 12;

    const loanAmountValue = parseFloat(calculatedLoanAmount.value);

    const monthlyPayment =
      (loanAmountValue * interestRatePerMonth) /
      (1 - Math.pow(1 + interestRatePerMonth, -numberOfPayments));

    const totalMortgage = monthlyPayment * numberOfPayments;

    const dividendOptions = {
      [BuilderTimePeriodEnum.PER_MONTH]: 12,
      [BuilderTimePeriodEnum.PER_WEEK]: 52,
    };

    const repaymentAmount =
      totalMortgage /
      loanTerm.value /
      dividendOptions[selectedTimePeriod.value];

    return repaymentAmount.toFixed(2);
  };

  const handleLoanChange = (value: string) => {
    const priceWithDeposit =
      props.packagePrice - props.packagePrice * depositPercentage.value;

    loanAmount.value = Math.max(0, Math.min(priceWithDeposit, parseInt(value)));
  };

  const selectDeposit = (depositValue: number) => {
    depositPercentage.value = depositValue;

    const priceWithDeposit =
      props.packagePrice - props.packagePrice * depositPercentage.value;

    loanAmount.value = Math.min(loanAmount.value, priceWithDeposit);
  };

  const handleInterestChange = (value: string) => {
    interestRate.value = Math.max(1, Math.min(parseFloat(value), 100));
  };

  const openAssumptions = () => {
    isAssumptionsOpen.value = !isAssumptionsOpen.value;

    setTimeout(() => {
      fadeInEffect.value = !fadeInEffect.value;
    }, 50);
  };

  const props = __props;

const __returned__ = { isDesktop, estateId, depositPercentage, interestRate, loanAmount, loanTerm, isAssumptionsOpen, fadeInEffect, timePeriod, selectedTimePeriod, selectTimePeriod, calculatedLoanAmount, calculateRepayments, handleLoanChange, selectDeposit, handleInterestChange, openAssumptions, props, get formatPrice() { return formatPrice }, DropDown, BuilderLoanAssumptions, ref, computed, get hexToRgba() { return hexToRgba }, get BuilderTimePeriodEnum() { return BuilderTimePeriodEnum }, get useIsDesktop() { return useIsDesktop }, get router() { return router }, get BuilderQuote() { return BuilderQuote } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})